/**
 * Web Style Import
 *
 */

import './style/dnb-switch.scss'
